import React from 'react';

import { createRoot } from 'react-dom/client';

import Screens from './screens';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(<Screens />);
}
